const getLocalizedUrl = (
  url: string | Record<string, string> | undefined,
  locale: string
) =>
  typeof url === 'string' || typeof url === 'undefined' ? url : url[locale];

export default getLocalizedUrl;
